import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  ClientEntity, TrialBalanceItem, Jaarrekening, Jaarrapportage, BokkzJrLogic
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from "rxjs";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-overige-bedrijfskosten',
  templateUrl: './spec-overige-bedrijfskosten.component.html',
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SharedUiButtonModule,
    SpecTrialbalanceComponent,
    SpecFormattedexplanationComponent,
    CommonModule
  ],
  styleUrls: ['./spec-overige-bedrijfskosten.component.scss']
})
export class SpecOverigeBedrijfskostenComponent implements OnInit,OnChanges,OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;

  public operatingExpensesOtherFg = {} as FormGroup;
  public personnelRelatedOtherExpensesFg = {} as FormGroup;
  public accommodationCostsFg = {} as FormGroup;
  public salesRelatedExpensesFg = {} as FormGroup;
  public carAndTransportCostsFg = {} as FormGroup;
  public officeRelatedExpensesFg = {} as FormGroup;
  public generalExpensesFg = {} as FormGroup;
  public operationalExpensesFg = {} as FormGroup;
  public undefinedOtherExpensesFg = {} as FormGroup;
  public operatingExpensesOtherDisclosureFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.operatingExpensesOtherFg = this.jrDataService.createFormGroupBalanceItem()
    this.personnelRelatedOtherExpensesFg = this.jrDataService.createFormGroupBalanceItem();
    this.accommodationCostsFg = this.jrDataService.createFormGroupBalanceItem();
    this.salesRelatedExpensesFg = this.jrDataService.createFormGroupBalanceItem();
    this.carAndTransportCostsFg = this.jrDataService.createFormGroupBalanceItem();
    this.officeRelatedExpensesFg = this.jrDataService.createFormGroupBalanceItem();
    this.generalExpensesFg = this.jrDataService.createFormGroupBalanceItem();
    this.operationalExpensesFg = this.jrDataService.createFormGroupBalanceItem();
    this.undefinedOtherExpensesFg = this.jrDataService.createFormGroupBalanceItem();
    this.operatingExpensesOtherDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
  }

  private patchData(value: JaarrapportageEntity) {

    const overigeBedrijfskosten = value.rapportage?.jaarrekeningen?.at(0)?.winstEnVerliesrekening?.overigeBedrijfskosten;

    if (overigeBedrijfskosten) {
      this.operatingExpensesOtherFg.reset();

      if (overigeBedrijfskosten.operatingExpensesOther) {
        this.operatingExpensesOtherFg.patchValue(overigeBedrijfskosten.operatingExpensesOther, {emitEvent: false})
      }

      const uitsplitsing = overigeBedrijfskosten.overigeBedrijfskostenUitsplitsing;
      const tekstueel = overigeBedrijfskosten.overigeBedrijfskostenTekstueel;

      if (uitsplitsing) {
        if (uitsplitsing.personnelRelatedOtherExpenses) {
          const subItem = uitsplitsing.personnelRelatedOtherExpenses;
          this.personnelRelatedOtherExpensesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.personnelRelatedOtherExpensesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.accommodationCosts) {
          const subItem = uitsplitsing.accommodationCosts;
          this.accommodationCostsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.accommodationCostsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.salesRelatedExpenses) {
          const subItem = uitsplitsing.salesRelatedExpenses;
          this.salesRelatedExpensesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.salesRelatedExpensesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.carAndTransportCosts) {
          const subItem = uitsplitsing.carAndTransportCosts;
          this.carAndTransportCostsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.carAndTransportCostsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.officeRelatedExpenses) {
          const subItem = uitsplitsing.officeRelatedExpenses;
          this.officeRelatedExpensesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.officeRelatedExpensesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.generalExpenses) {
          const subItem = uitsplitsing.generalExpenses;
          this.generalExpensesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.generalExpensesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.operationalExpenses) {
          const subItem = uitsplitsing.operationalExpenses;
          this.operationalExpensesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.operationalExpensesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.undefinedOtherExpenses) {
          const subItem = uitsplitsing.undefinedOtherExpenses;
          this.undefinedOtherExpensesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.undefinedOtherExpensesFg.get('trialBalanceItems') as FormArray)
        }
      }
      if (tekstueel) {
        if (tekstueel.operatingExpensesOtherDisclosure) {
          this.operatingExpensesOtherDisclosureFg.patchValue(tekstueel.operatingExpensesOtherDisclosure);
        }
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i], {emitEvent: false});
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup, {emitEvent: false});
        }
      }
    }
  }

  public saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
    this.operatingExpensesOtherFg.updateValueAndValidity({ emitEvent: false });
    this.personnelRelatedOtherExpensesFg.updateValueAndValidity({ emitEvent: false });
    this.accommodationCostsFg.updateValueAndValidity({ emitEvent: false });
    this.salesRelatedExpensesFg.updateValueAndValidity({ emitEvent: false });
    this.carAndTransportCostsFg.updateValueAndValidity({ emitEvent: false });
    this.officeRelatedExpensesFg.updateValueAndValidity({ emitEvent: false });
    this.generalExpensesFg.updateValueAndValidity({ emitEvent: false });
    this.operationalExpensesFg.updateValueAndValidity({ emitEvent: false });
    this.undefinedOtherExpensesFg.updateValueAndValidity({ emitEvent: false });
    this.operatingExpensesOtherDisclosureFg.updateValueAndValidity({ emitEvent: false });

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        winstEnVerliesrekening: {
          ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening,
          overigeBedrijfskosten: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.overigeBedrijfskosten,
            overigeBedrijfskostenUitsplitsing: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.overigeBedrijfskosten?.overigeBedrijfskostenUitsplitsing,
              personnelRelatedOtherExpenses: this.personnelRelatedOtherExpensesFg.value,
              accommodationCosts: this.accommodationCostsFg.value,
              salesRelatedExpenses: this.salesRelatedExpensesFg.value,
              carAndTransportCosts: this.carAndTransportCostsFg.value,
              officeRelatedExpenses: this.officeRelatedExpensesFg.value,
              generalExpenses: this.generalExpensesFg.value,
              operationalExpenses: this.operationalExpensesFg.value,
              undefinedOtherExpenses: this.undefinedOtherExpensesFg.value,
            },
            overigeBedrijfskostenTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.overigeBedrijfskosten?.overigeBedrijfskostenTekstueel,
              operatingExpensesOtherDisclosure: this.operatingExpensesOtherDisclosureFg.value,
            }
          }
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogicService.getCalculation(this.jrEntity)
  }
}

